import React from 'react';
import {connect} from "react-redux";
import {setInstagramAccessToken} from "../../../../../state/actions/authActions";
import {API_ROOT} from "../../../../../baseUrls";
import ImportButton from "./ImportButton";
import {Instagram} from "@mui/icons-material";
import {buildFormData} from "../../../../../state/actions/actionUtils";

function InstagramImport(props) {
  const { mindfile, importSource, instagramAccessToken, setInstagramAccessToken } = props;

  const connectToInstagram = () => {
    let InstagramPopup;
    // This function will be called from the InstagramPopup window:
    window.instagram_access_token = token => {
      InstagramPopup.close();
      setInstagramAccessToken(token);
    };
    InstagramPopup = window.open(`${API_ROOT}/mindfiles/${mindfile.id}/instagram/connect`, 'lnInstagramConnect', 'width=640,height=320');
  }

  return (
    <ImportButton
      importSource={importSource}
      source={"instagram"}
      label={"Instagram"}
      icon={<Instagram />}
      handleConnect={connectToInstagram}
      importFormData={!instagramAccessToken ? null : buildFormData({'instagram_access_token': instagramAccessToken})}
    />
  );
}


const mapStateToProps = state => {
  return {
    mindfile: state.mindfile,
    instagramAccessToken: state.auth.instagram_access_token,
  };
};

const mapDispatchToProps = {
  setInstagramAccessToken,
};

export default connect(mapStateToProps, mapDispatchToProps)(InstagramImport);
